import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Response } from "../shared/models/Response";
import { Noticia } from "../models/Noticia";

@Injectable({
  providedIn: 'root'
})
export class NoticiaService {

  private REST_API_SERVER = environment.backend_server + "/noticias";
  constructor(private http: HttpClient) {}

  latestNews(): Observable<Response<Noticia[]>> {
     return this.http.get<Response<Noticia[]>>(this.REST_API_SERVER + "/get");
  }


  
}
